module.exports = __webpack_public_path__ + "img/Pic_ZS_XSCG.f7d89ac9.png";